import React, { useContext, memo } from "react";
import { Data } from "../App";
import Series from "./Series";

// ランク単位で分割
const Rank = memo(() => {
  // フィルター後のデータを参照
  const { filteredList } = useContext(Data);
  // ランク一覧（自動取得する場合はonNOYES生地に注意）
  const rankList = ["F1", "F2", "F3", "L1", "L2"];

  if (filteredList.length > 0) {
    return (
      <section className="list_wrapper">
        {rankList.map((rank, i) => {
          const rankData = filteredList.filter((item) => item.zero === rank);
          return (
            <>
              {rankData.length > 0 ? (
                <div id={rankData[0].kijilink} key={i} className="rank_container">
                  <h2>
                    <b className="en">{rank}</b>
                    <p>ランク</p>
                    <span></span>
                    <div>
                      {rank.includes("F") ? "FABRIC" : "LEATHER"}
                      <span className="en">
                        COLLECTION
                        <b>{rank.includes("F") ? "布生地" : "レザー生地"}</b>
                      </span>
                    </div>
                  </h2>
                  <Series data={rankData} />
                </div>
              ) : null}
            </>
          );
        })}
      </section>
    );
  } else {
    return <section className="null"></section>;
  }
});

export default Rank;
